<template>
  <!-- select 2 demo -->
  <b-modal
    id="modal-select2"
    title="Agendamento de Tarefa"
    ok-title="Agendar"
    cancel-variant="outline-secondary"
    cancel-title="fechar"
    @ok="handleOk"
  >
    <b-form>
      <!----<b-form-group
          label="Motivo"
          label-for="vue-select"
        >
          <v-select
            id="vue-select"
            v-model="status"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="option"
            label="text"
          />
        </b-form-group>--->
      <b-form-group
        label="Data do Agendamento"
        label-for="data-agenda"
      >
        <b-form-datepicker
          id="data-agenda"
          v-model="schedule_date"
          local="en"
          class="mb-2"
          today-variant="danger"
        />
      </b-form-group>
      <b-form-group
        label="Descrição"
        label-for="name"
      >
        <b-form-textarea
          id="textarea-no-resize"
          v-model="observations"
          placeholder="escreva os detalhes aqui"
          rows="3"
          no-resize
        />
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BButton, BModal, VBModal, BForm, BFormInput, BFormGroup, BCardText, BFormDatepicker, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { getUserData } from '@/auth/utils'
import attending from '../../functions/basics/attending'

export default {
  components: {
    BCardCode,
    BButton,
    BModal,
    BForm,
    BFormInput,
    BCardText,
    BFormGroup,
    vSelect,
    BFormDatepicker,
    BFormTextarea,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    subattending: Object,
  },
  data() {
    return {
      observations: null,
      schedule_date: null,
      status: 'selecione um motivo',
      option: [
        {
          text: 'Aguardando Contato',
          value: 1,
        },
        {
          text: 'Contactado por WhatsApp',
          value: 2,
        },
        {
          text: 'Contactado por Telefone',
          value: 3,
        },
        {
          text: 'Contactado por SMS',
          value: 4,
        },
        {
          text: 'Contactado por E-mail',
          value: 5,
        },
        {
          text: 'Agendado',
          value: 6,
        },
        {
          text: 'Sem WhatsApp',
          value: 7,
        },
        {
          text: 'Não Responde',
          value: 8,
        },
        {
          text: 'Não Comprou',
          value: 9,
        },
        {
          text: 'Rastreio Enviado',
          value: 10,
        },
      ],
    }
  },
  methods: {
    async handleOk() {
      const data = await getUserData()
      attending.createScheduling(data.mc_access_token, this.subattending.id, this.observations, this.schedule_date)
      // console.log(this.subattending.id)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
